document.addEventListener("DOMContentLoaded", function () {
	// zip
	document
		.querySelector("[data-zip-trigger]")
		.addEventListener("click", function () {
			const modalHost = document.querySelector("quadpay-modal-base");
			if (modalHost) {
				const shadow = modalHost.shadowRoot;
				const modal = shadow.querySelector("#qp-modal__overlay");
				modal.style.display = "block";
			}
		});
	// afterpay

	document
		.querySelector("[data-afterpay-trigger]")
		.addEventListener("click", function () {
			const modalHost = document.querySelector("square-placement");
			if (modalHost) {
				const shadow = modalHost.shadowRoot;
				const button = shadow.querySelector(".afterpay-logo");
				button.click();
			}
		});
});
